<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-subtitle>{{$t('* Required fields')}}</v-card-subtitle>
      <v-card-subtitle v-if="!newUser">{{ editedItem.email }}</v-card-subtitle>
      <v-card-text>
        <validation-observer ref="form">
          <v-container>
            <validation-provider
              v-if="newUser"
              v-slot="{errors}"
              name="email"
              rules="required|max:255|email"
            >
              <v-text-field
                data-cy="text-field-email-user"
                name="email"
                v-model="editedItem.email"
                :label="`${$t('E-mail')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-if="newUser || !isAdminReseller"
              v-slot="{errors}"
              name="role_id"
              rules="required"
            >
              <v-select
                data-cy="select-input-role-user"
                :label="`${$t('Role')} *`"
                :items="roles"
                item-text="label"
                item-value="id"
                v-model="editedItem.role_id"
                :error-messages="errors"
              ></v-select>
            </validation-provider>
            <v-text-field v-else label="Rôle" :value="$t('Admin reseller')" disabled></v-text-field>
            <validation-provider v-slot="{errors}" name="reseller_entities_id" rules="required">
              <v-select
                data-cy="select-input-entity-user"
                :label="`${$t('Entities')} *`"
                :items="entities"
                item-text="name"
                item-value="id"
                multiple
                v-model="editedItem.reseller_entities_id"
                :error-messages="errors"
              ></v-select>
            </validation-provider>
          </v-container>
        </validation-observer>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="$emit('close')">{{ $t('Cancel') }}</v-btn>
        <v-btn
          data-cy="button-save-new-user"
          color="primary"
          :loading="loading"
          text
          @click.stop="save"
        >{{ $t('Save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "AddEditEntityDialog",
  props: ["value"],
  components: { ValidationObserver, ValidationProvider },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    dialog(value) {
      if (value && this.$refs.form) {
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    ...mapState({
      editedId: (state) => state.users.editedId,
      entities: (state) => state.entities.items,
      roles: (state) => state.roles.items,
    }),
    editedItem: {
      get() {
        return this.$store.state.users.editedItem;
      },
      set(value) {
        this.$store.commit("users/setEditedItem", value);
      },
    },
    newUser() {
      return this.editedId === -1;
    },
    formTitle() {
      return this.editedId === -1
        ? this.$t("New user")
        : this.$t("Modify user");
    },
    isAdminReseller() {
      return this.editedItem.is_admin_reseller;
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        if (this.editedId === -1) {
          this.$store
            .dispatch("users/saveEditedItem")
            .then(() => {
              this.$refs.form.reset();
              this.loading = false;
              this.dialog = false;
              this.snackbar("success", this.$t("snackbar-message-user.added"));
            })
            .catch(this.responseError);
        } else {
          this.$store
            .dispatch("users/updateEditedItem")
            .then(() => {
              this.$refs.form.reset();
              this.loading = false;
              this.dialog = false;
              this.snackbar(
                "success",
                this.$t("snackbar-message-user.updated")
              );
            })
            .catch(this.responseError);
        }
      });
    },
    responseError(error) {
      this.loading = false;
      if (error.response && error.response.status === 422) {
        let errors = error.response.data.errors;
        this.$refs.form.setErrors(errors);
      } else {
        this.snackbar("error", this.$t("snackbar-message-user.error"));
      }
    },
  },
};
</script>